import { Component, OnInit } from '@angular/core';
import { JhiLanguageService } from '../../shared/core-utils';
import { VariableDetails } from '../../shared/ontology/model/variable-details';
import { VariableDetailsContext } from './variable-details.context';
import { DataTypeEnum } from '../../shared/ontology/data-type.enum';

@Component({
    selector: 'jhi-valid-values',
    templateUrl: './valid-values.component.html',
})
export class ValidValuesComponent implements OnInit {

    dataType = DataTypeEnum;
    variableDetails: VariableDetails;

    constructor(private languageService: JhiLanguageService,
                private variableDetailsContext: VariableDetailsContext
    ) {

    }

    ngOnInit(): void {
        const currentLang = this.languageService.getCurrentLanguage();
        this.languageService.changeLanguage(currentLang);

        this.variableDetailsContext.variableDetails.subscribe((variableDetails: VariableDetails) => this.variableDetails = variableDetails);
    }

}
